/**
 *
 *
 * @param name
 * @param type
 * @param content
 * @param roles
 * @returns {Promise<void>}
 */
import {apiDELETE, apiGET, apiPOST, apiPUT} from "./RequestsCore";

/**
 * Returns all the existing users in the app, without pagination.
 *
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function getUsers() {
    return await apiGET('/api/admin/users');
}

/**
 * Creates a new user with the provide data.
 *
 * @param user
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function createUser(user) {
    return await apiPOST('/api/admin/user', user);
}

/**
 * Updates the provided user with the provide data.
 *
 * @param user
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function editUser(user) {
    return await apiPUT('/api/admin/user/' + user.id, user);
}

/**
 * Deletes the provided user
 *
 * @param user
 * @returns {Promise<null|T|AxiosResponse<*>|*>}
 */
export async function deleteUser(user) {
    return await apiDELETE('/api/admin/user/' + user.id);
}
